/*
 * Usage:
 * syntax: <input oly-next-tab="target" oly-next-tab-reverse="boolean" />
 * target: value of the name attribute of the input to be tabbed to (required as getting the 'next' element is complicated)
 * reverse: a boolean which indicates whether this functionality is required for tab or shift+tab (reverse is true if wanted for shift+tab, false otherwise)
 *
 * example 1: The following will tab to an input with id 'toggle-button' when the submit button is pressed
 *          <input type="text" id="Submit" oly-next-tab="toggle-button" reverse="false/>
 * example 2: The following will tab back to the submit button from the toggle button. If only tab is pressed (no shift) then the normal tabbing behaviour will occur
 *          <input type="text" id="toggle-button" oly-next-tab="Submit" reverse="true/>
 */

module.exports = function () {
    return {
        restrict: 'A',
        scope: {
            target: '@olyNextTab',
            reverse: '=?olyNextTabReverse'
        },
        link(scope, element) {
            scope.reverse = !!scope.reverse;

            element.on('keydown', function (event) {
                const key = event.which || event.keyCode;
                // when key!=9 tab key isn't pressed.
                // When scope.reverse is true, we only want to manually change focus if shift+tab is pressed.
                // if scope.reverse is false, we DON'T want to manually change focus if shift+tab is pressed.
                if (key !== 9 || scope.reverse !== event.shiftKey) {
                    return;
                }
                // Current active element is captured to check whether focus has moved
                const elem = document.activeElement;
                document.getElementById(scope.target).focus();
                if (document.activeElement !== elem) {
                    // Only prevent default behaviour if focus has actually moved (Stops normal tab behaviour breaking).
                    event.preventDefault();
                }
            });
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/nexttab/nexttab-directive.js
 **/